export enum PERMISSIONS {
  APP_MESSAGES_ACCESS = 'app.messages.access',
}
